import React, { Component, Fragment } from "react";
import cx from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faRotate,
    faMagnifyingGlass, faFilter
} from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import DateRangePicker from "./DateRangePicker";
import { showToast, getFormatDateRange } from "./Appcommon";


export default class FormHeader extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searchFocused: [],
            selectedOptions: [],
            selectOptions: this.props.selectOptions || [],
            header: this.props.prefix === "calls_analytics" ? getFormatDateRange(new Date(), new Date()) + " - Total Days : 7" : "",
            isMultiSelectOpen: false,
            isMenuOpen: -1,
            sevenDaysAgo: null
        };
        this.menuRef = React.createRef();
    }

    componentDidMount() {
        window.addEventListener('click', this.toggleDropdown);
        const currentDate = new Date();
        const sevenDaysAgoDate = new Date(currentDate);
        sevenDaysAgoDate.setDate(currentDate.getDate() - 6);
        if (this.props.prefix === "calls_analytics") {
            this.setState({
                header: getFormatDateRange(sevenDaysAgoDate.toISOString().split('T')[0], currentDate) + " - Total Days : 7",
            });
        }
    }

    componentWillReceiveProps = async (nextProps) => {
        let { selectOptions } = nextProps;
        let { selectedOptions } = this.state;
        selectOptions && selectOptions.map((options, selectindex) => {
            let name = options.name;
            if (name === "Dashboard") {
                let defaultvalue = options.defaultvalue;
                selectedOptions[name] = defaultvalue;
            }
        })
        this.setState({
            selectOptions: selectOptions,
            selectedOptions: selectedOptions
        })
    }

    componentWillUnmount() {
        window.removeEventListener('click', this.toggleDropdown);
    }

    handleSearch = async (name, e) => {
        let searchTxt = e.target.value;
        await this.props.handleSearch(name, searchTxt);
    }

    handleBtnClick = async (name, e, label, value) => {
        e.preventDefault();
        this.props.handleBtnClick(name, e, label, value);
    }

    handleChange = (option, selectedOption) => {
        let name = option.name;
        let isMultiple = option.multiple;
        let { selectedOptions } = this.state;
        if (isMultiple) {
            if (selectedOption !== undefined && selectedOption[0] !== undefined) {
                if (selectedOption[0].group !== undefined && selectedOption[0].group !== '') {
                    name = selectedOption[0].group;
                }
            }
        }
        selectedOptions[name] = selectedOption;
        this.setState({ selectedOptions });
        this.props.handleSelectChange(name, selectedOption, isMultiple);
    }

    handleSearchFocus = (name, val) => {
        let { searchFocused } = this.state;
        searchFocused[name] = val;
        this.setState({ searchFocused });
    }

    handleDateChange = (name, selectedDates, noofdays) => {
        let { prefix } = this.props;

        if((noofdays <= 180 && prefix === "calls_analytics") || prefix !== "calls_analytics"){
            this.props.handleDateChange(name, selectedDates, noofdays);
            if(prefix === "calls_analytics"){
                this.setState({
                    header : getFormatDateRange(selectedDates[0], selectedDates[1]) +  " - Total Days : " + noofdays
                })
                this.props.handleBtnClick();
            }
        } else {
            let errormsg = "Date range should not be greater than 180 days";
            showToast(errormsg, "top-right", "error");
        }
    }

    toggleDropdown = (e, name = 'event', id = -1) => {
        let { isMenuOpen } = this.state;
        /* if(this.menuRef.current && !this.menuRef.current.contains(e.target)){
            let isOpenId = -1;
            if(name === 'dropdown'){
                isOpenId = id;
            }else if((id !== "") && ((name === 'btnClicked') || (this.menuRef.current && !this.menuRef.current.contains(name.target)))) {
                isOpenId = -1;
            }
            this.setState({
                isMenuOpen: isOpenId,
            });
        } */

        if (this.menuRef.current && !this.menuRef.current.contains(e.target)) {
            this.setState({
                isMenuOpen: -1
            })
        } else if (name === 'dropdown' && isMenuOpen === -1) {
            this.setState({
                isMenuOpen: id
            })
        }
    };

    render() {

        let { selectOptions, searchFocused, header, isMultiSelectOpen, isMenuOpen } = this.state;
        let { buttonOptions, searchOptions, dateOptions, prefix, headerText, headerDesc, moreActions, preFilterButtonOptions, moreActionComponent, moreFilterActions } = this.props;

        if (header !== '') {
            headerText = header;
        }

        return (
            <Fragment>
                <div className={cx("tab-listview-header header-btn", { 'call-log-filter': prefix === 'calls_analytics' })}>
                    {headerText !== undefined && headerText !== "" ? <div className="listview-btn-left pt-0 wd-55 d-flex">
                        <div className={`listview-defaultgroup semi-bold`} id="defaultactionleft">
                            <div className="flex-center-v pR header-default">
                                <div className="form-field">
                                    <div className="form-field-wrapper">
                                        <div className="custom-view-options pull-left d-flex">
                                            {moreActions !== undefined &&
                                                <div> {
                                                    moreActions.map((action) => {
                                                        return (
                                                            <button onClick={(e) => { action.clickEvent(e) }} className="filter-btn icon-round-btn filter-active">
                                                                <span className="top-nav-btn notification-icon">
                                                                    <FontAwesomeIcon className="ms-2 opacity-8 bigin-sprite ignite-icon-notification" icon={action.icon} />
                                                                </span>
                                                            </button>
                                                        )
                                                    })
                                                }
                                                </div>
                                            }

                                            {headerText !== undefined && headerText !== "" &&
                                                <div>
                                                    <span className={cx('screen-header-text', { 'calllog-header': prefix === "calls_analytics" })}>{headerText}</span>
                                                    {headerDesc !== undefined && headerDesc !== "" && <div className={'screen-header-desc'}>
                                                        {headerDesc}
                                                    </div>}
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> : <></>}

                    <div className="listview-btn-right pt-0">
                        <div className="listview-options-div flex" >
                            {
                                dateOptions != undefined &&
                                dateOptions.map((dateOption) => {
                                    return (
                                        <div className={cx('mR10 ', { 'formheader-text-search-box': prefix === 'calls_analytics', 'header-filter': prefix === 'analytics' },dateOption.customClass)}>
                                            <DateRangePicker config={dateOption} handleDateChange={this.handleDateChange} />
                                        </div>
                                    );
                                })
                            }
                            {
                                moreFilterActions !== undefined &&
                                moreFilterActions.map((options, selectindex) => {
                                    let name = options.name;
                                    let selectedOption = this.state.selectedOptions[name];
                                    if (selectedOption === undefined && options.selectedTemplate !== undefined) {
                                        selectedOption = options.selectedTemplate;
                                    }
                                    if (selectedOption === undefined) {
                                        selectedOption = options.options[0];
                                    }
                                    let placeHolder = options.placeHolder !== undefined ? options.placeHolder : name;
                                    return (
                                        <div key={selectindex} className={cx('custom-user-filter')}>
                                            <div className={cx(`le-form-row `, { 'calllog-type-select': prefix === 'calls_analytics' && !options.multiple })}>
                                                <div className={`le-form-field`}>
                                                    <Select
                                                        name={`${name}-filter`}
                                                        onChange={(eve) => { this.handleChange(options, eve) }}
                                                        placeholder={placeHolder}
                                                        defaultValue={options.defaultvalue}
                                                        value={selectedOption}
                                                        options={options.options}
                                                        className="basic-multi-select w-100"
                                                        classNamePrefix="le-select"
                                                        menuPlacement={"bottom"}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                        {
                            moreFilterActions !== undefined && <div className="spacer"></div>
                        }
                        <div className="listview-options-div flex " id="defaultactionright" ref={this.menuRef}>
                            <div>
                                {
                                    preFilterButtonOptions != undefined &&
                                    preFilterButtonOptions.map((button) => {
                                        let btnCaption = button.caption;
                                        return (
                                            <div className="d-flex">
                                                {btnCaption !== undefined && btnCaption !== "" && <span className="screen-header-text-new">{btnCaption}</span>}
                                                <span className={cx("double-primary-btn mR7 lv-header-module-create-import-btn ", { 'create-temp-width': button.label === 'Create Template' }, { 'custom-width-1': button.label === 'Sync' }, button.className,)}>
                                                    <le-button className="btn-add header-btn">
                                                        <button type="button" onClick={(event => { this.handleBtnClick(button.name, event, button.label, button.value) })} className={cx("le-button lePrimaryBtn add-user-btn m-1", { "formheader-search-btn": prefix === 'calls_analytics' })}>
                                                            <span className="ux-icon-button">
                                                                {button.icon && <FontAwesomeIcon icon={button.icon} className={`mr-1`} />}
                                                                <span className="double-btn-text" data-ellipsis="true">{button.label}</span>
                                                            </span>
                                                        </button>
                                                    </le-button>
                                                </span>
                                            </div>
                                        );
                                    })
                                }
                            </div>
                            {
                                searchOptions != undefined &&
                                searchOptions.map((searchOption) => {
                                    return (
                                        <div className={cx('searchSection le-setup-info-search pR mR10 ', searchOption.customClass, { 'header-filter': prefix === 'analytics' })}>
                                            <div className={`le-form-row`}>
                                                <div className={`le-form-field`}>
                                                    <div className={cx(`le-form-field-input`, { 'leInputFocus': searchFocused[searchOption.name] != undefined && searchFocused[searchOption.name] })}>
                                                        <div className={`le-search-picklist`}>
                                                            <div className={`le-search`}>
                                                                <div className={`le-field-search`}>
                                                                    <div className={`le-field-input le-field-input-box`}>
                                                                        <div className={`le-field-input-box-search`}>
                                                                            <input
                                                                                type="text"
                                                                                onFocus={() => { this.handleSearchFocus(searchOption.name, true) }}
                                                                                onBlur={() => { this.handleSearchFocus(searchOption.name, false) }}
                                                                                onKeyUp={(e) => { this.handleSearch(searchOption.name, e) }}
                                                                                name={`${searchOption.name}-search`}
                                                                                autoComplete="off"
                                                                                className="le-form-input "
                                                                                placeholder={searchOption.placeHolder} />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className={`le-field-icon-wrap`}>
                                                                <span className={`le-search-info-text pe-none`}></span>
                                                                <span className={`le-fwrap-item`}>
                                                                    <FontAwesomeIcon icon={faMagnifyingGlass} />
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })
                            }

                            {
                                selectOptions != undefined &&
                                selectOptions.map((options, selectindex) => {
                                    let name = options.name;
                                    let customClass = "";
                                    let selectedOption = this.state.selectedOptions[name];
                                    if (selectedOption === undefined && options.selectedTemplate !== undefined) {
                                        selectedOption = options.selectedTemplate;
                                    }
                                    if (selectedOption === undefined) {
                                        selectedOption = options.options[0];
                                    }
                                    let defaultValue = options.defaultvalue;
                                    if(defaultValue !== undefined){
                                        if(!(typeof(defaultValue) === "number")){
                                            selectedOption = defaultValue;
                                        }else{
                                            defaultValue = options.options[defaultValue];
                                        }
                                    }
                                    if(options.customClass !== undefined){
                                        customClass = options.customClass;
                                    }
                                    if (prefix === 'calls_analytics') {
                                        options.name = options.label;
                                    }
                                    let customStyle = {};
                                    if (options.customStyles !== undefined) {
                                        customStyle = options.customStyles;
                                    }
                                    let openMenuBox = (isMenuOpen === selectindex) ? true : false;
                                    let placeHolder = options.placeHolder !== undefined ? options.placeHolder : name;
                                    return (
                                        <div key={selectindex} className={cx('searchSection pR mR10 ' + customClass , { "temp-width": prefix !== 'calls_analytics'}, {'le-setup-info-search': options.multiple},{'header-filter ': prefix === 'analytics' })}>
                                            <div className={cx(`le-form-row`, { 'calllog-type-select': prefix === 'calls_analytics' && !options.multiple })}>
                                                <div className={`le-form-field`}>
                                                    {options.multiple ?
                                                        <span
                                                            className="d-inline-block header-multiselect-filter"
                                                            data-toggle="popover"
                                                            data-trigger="focus"
                                                            data-content="Please selecet account(s)"
                                                            onClick={e => this.toggleDropdown(e, 'dropdown', selectindex)}
                                                        >
                                                            <ReactMultiSelectCheckboxes
                                                                className={"filter-multiselect 11"}
                                                                name="multiselectbox"
                                                                options={options.options}
                                                                onChange={(eve) => { this.handleChange(options, eve) }}
                                                                placeholderButtonLabel={options.name}
                                                                value={this.state.optionSelected}
                                                                menuIsOpen={openMenuBox}
                                                                //closeMenuOnSelect = {true}
                                                                menuPlacement={"bottom"}
                                                            />
                                                        </span>
                                                        : <Select
                                                            isMulti={false}
                                                            isClearable={false}
                                                            name={`${name}-filter`}
                                                            onChange={(eve) => { this.handleChange(options, eve) }}
                                                            placeholder={placeHolder}
                                                            defaultValue={defaultValue}
                                                            value={selectedOption}
                                                            options={options.options}
                                                            className="basic-multi-select w-100"
                                                            classNamePrefix="le-select"
                                                            menuPlacement={"bottom"}
                                                            styles={customStyle}
                                                        />
                                                    }

                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                        <div className="listview-options-div flex">
                            {
                                buttonOptions != undefined &&
                                buttonOptions.map((button) => {
                                    return (
                                        <span className={cx("double-primary-btn mR7 lv-header-module-create-import-btn ", { 'create-temp-width': button.label === 'Create Template' }, { 'custom-width-1': button.label === 'Sync' }, button.className,)}>
                                            <le-button className="btn-add header-btn">
                                                <button type="button" onClick={(event => { this.handleBtnClick(button.name, event, button.label, button.value) })} className={cx("le-button lePrimaryBtn add-user-btn mR20", { "formheader-search-btn": prefix === 'calls_analytics' })}>
                                                    <span className="ux-icon-button">
                                                        {button.icon && <FontAwesomeIcon icon={button.icon} className={`mr-1`} />}
                                                        <span className="double-btn-text" data-ellipsis="true">{button.label}</span>
                                                    </span>
                                                </button>
                                            </le-button>
                                        </span>
                                    );
                                })
                            }
                        </div>
                        <div>
                            {moreActionComponent}
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }

}
